import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import { SITE_NAME, staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_shop.style'

const getClientModule = () => import('src/clientRoutes/_shop.style')

export const handle = { name: 'style' }

/** SSR loader. Source: https://github.com/troph-team/pixai/blob/main/packages/pixai-server/src/ssr/router.ts#L516-L527 */
export function loader({ request, context }: Route.LoaderArgs) {
  const { t, exists } = getI18n(context)
  const title = t('server:meta.style-shop.title', { defaultValue: 'Style Shop' })
  const imageKey = 'server:meta.style-shop.image'
  return staticMetaLoader({
    requestUrl: request.url,
    title: `${title} | ${SITE_NAME}`,
    description: t('server:meta.style-shop.description'),
    image: exists(imageKey) ? t(imageKey) : undefined,
  })
}

/** Meta function for SSR SEO. */
export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
